import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71891692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute top-0 left-0 h-full bg-gradient-to-b from-[#00000020] to-[#00000095] flex flex-col p-5 w-full rounded-lg z-10 opacity-0 group-hover:opacity-100 transition-opacity" }
const _hoisted_2 = { class: "project-description mt-auto text-white" }
const _hoisted_3 = { class: "font-bold font-captions text-3xl" }
const _hoisted_4 = { class: "text-xl" }
const _hoisted_5 = ["src"]


import {ProjectItem} from "@/store"
import ProjectAttributes from "@/components/ProjectAttributes"


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryApplication',
  props: {
    project: {}
  },
  setup(__props: any) {

const props = __props;



function loadThumbnail() {
    return require(`@/assets/applications/${props.project.image}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: 'ProjectView', params: {id: _ctx.project.id}}))),
    class: "project-gallery-item aspect-[3/2] rounded-lg relative group overflow-hidden cursor-pointer hover:shadow-lg border border-gray-300"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ProjectAttributes), {
        class: "pointer-events-none",
        attributes: props.project.attributes
      }, null, 8, ["attributes"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.project.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.project.summery), 1)
      ])
    ]),
    _createElementVNode("img", {
      src: loadThumbnail(),
      alt: "project.title",
      class: "relative w-full h-full object-cover"
    }, null, 8, _hoisted_5)
  ]))
}
}

})